import { Dispatch, memo, SetStateAction } from "react";
import Button from "components/Elements/Button/Button";
import Icon from "components/Elements/Icon/Icon";

import styles from "./sendThanksBtn.module.scss";

interface SendThanksBtnI {
  setActiveModal: Dispatch<
    SetStateAction<
      "amount-for-thanks" | "complete-purchase" | "thanks-form-modal"
    >
  >;
  sliderValue: number;
  nextModalId: "amount-for-thanks" | "complete-purchase" | "thanks-form-modal";
  title: string;
}

const SendThanksBtn = memo(
  ({ title, setActiveModal, sliderValue, nextModalId }: SendThanksBtnI) => {
    const handleNext = () => {
      setActiveModal(nextModalId);
    };

    return (
      <Button
        onClick={handleNext}
        className={styles.sendButton}
        disabled={sliderValue === 0}
      >
        <Icon name="heart" white large />
        {title}
      </Button>
    );
  }
);
export default SendThanksBtn;
